import React, { useState } from 'react'
import { Wrapper } from './style'
import './style.css'
const DataListInput = require('react-datalist-input').default

export interface ISelectFilterProps {
  value: string
  onChange: Function
  options: string[]
  name: string
  style?: any
}

let id: any

export const SelectFilter: React.FC<ISelectFilterProps> = ({
  value,
  onChange,
  name,
  options,
  ...p
}) => {
  const [inputValue, setInputValue] = useState(value)

  const handleChange = (value: string) => {
    setInputValue(value)
    clearTimeout(id)
    id = setTimeout(() => {
      if (options.includes(value) || value === '') {
        onChange(value)
      }
    }, 900)
  }

  const items = options.map((oneItem) => ({
    label: oneItem,
    key: oneItem
  }))

  return (
    <Wrapper {...p} className="select-filter">
      <div
        className={
          (value ? 'dropdown-active' : '') +
          ' d-inline-block form-control py-0 pl-1'
        }
        style={{
          height: 39,
          padding: 0
        }}
      >
        <DataListInput
          placeholder="Select specialty"
          className={value ? 'dropdown-active' : ''}
          items={items}
          onInput={(e: any) => setInputValue(e)}
          onSelect={(d: any) => {
            if (d.key) handleChange(d.key)
          }}
          value={inputValue}
          itemClassName="datalist-autocomplete-option"
        />

        {value ? (
          <i
            role="button"
            onClick={() => {
              onChange('')
              setInputValue('')
            }}
            className="icon-cancel fs-8 text-danger pr-2"
            style={{
              position: 'relative',
              top: '2px'
            }}
          />
        ) : (
          <i
            className="icon-dropdown fs-8 pr-2"
            style={{
              fontSize: 12.5
            }}
          />
        )}
      </div>
    </Wrapper>
  )
}

export default SelectFilter
